import { apiFetch } from '@/lib/api';
import type { MediaModel, MediaGeneration, GenerateInput } from '@/types/media';

const M = '/media-models';
const G = '/media/generations';

export const listMediaModels = () => apiFetch<MediaModel[]>(M);
export const createMediaModel = (b: Partial<MediaModel>) => apiFetch<MediaModel>(M, { method: 'POST', body: JSON.stringify(b) });
export const updateMediaModel = (model: string, b: Partial<MediaModel>) => apiFetch<MediaModel>(`${M}/${encodeURIComponent(model)}`, { method: 'PUT', body: JSON.stringify(b) });
export const deleteMediaModel = (model: string) => apiFetch(`${M}/${encodeURIComponent(model)}`, { method: 'DELETE' });

export const generate = (b: GenerateInput) => apiFetch<MediaGeneration>(G, { method: 'POST', body: JSON.stringify(b) });
export const getGeneration = (id: string) => apiFetch<MediaGeneration>(`${G}/${id}`);
export const cancelGeneration = (id: string) => apiFetch<MediaGeneration>(`${G}/${id}/cancel`, { method: 'POST' });
export const listGenerations = (q: { modality?: string; model?: string; status?: string; tag?: string; sourceTopicNo?: string; page?: number; pageSize?: number }) => {
  const p = new URLSearchParams();
  Object.entries(q).forEach(([k, v]) => { if (v !== undefined && v !== '') p.set(k, String(v)); });
  return apiFetch<{ data: MediaGeneration[]; page: number; total: number }>(`${G}?${p.toString()}`);
};
export const patchGenerationTags = (id: string, tags: string[]) => apiFetch<MediaGeneration>(`${G}/${id}`, { method: 'PATCH', body: JSON.stringify({ tags }) });
export const deleteGeneration = (id: string) => apiFetch(`${G}/${id}`, { method: 'DELETE' });
